<template lang="pug">
  el-container
    Header
    el-main
      .mainvisual
        picture
          source(media='(min-width: 1200px)', srcset='../assets/image/pc-first-view.png')
          source(media='(min-width: 768px)', srcset='../assets/image/ipad-first-view.png')
          source(media='(min-width: 321px)', srcset= '../assets/image/sp-first-view.png')
          img(src='../assets/image/sp-first-view.png', alt='first-view')
        picture
          source(media='(min-width: 1200px)', srcset= '../assets/image/pc-pickup-recruit.png')
          source(media='(min-width: 768px)', srcset='../assets/image/ipad-pickup-recruit.png')
          source(media='(min-width: 321px)', srcset= '../assets/image/sp-pickup-recruit.png')
          img(src='../assets/image/sp-pickup-recruit.png', alt='pickup-recruit')
        .recruit-btn-area
          .recruit-btn
            a(href='https://www.mht-code.com/recruit_engineer.html', target="_blank", data-hover="詳細はこちら") 詳細はこちら
        picture
          source(media='(min-width: 1200px)', srcset='../assets/image/pc-contact.png')
          source(media='(min-width: 768px)', srcset= '../assets/image/ipad-contact.png')
          source(media='(min-width: 321px)', srcset= '../assets/image/sp-contact.png')
          img(src='../assets/image/sp-contact.png', alt='contact')
        .contact
          .twitter-widget.contact-twitter-link
            v-timeline.twitter-timeline(:id="twitterId", :source-type="'profile'")
        picture
          source(media='(min-width: 1200px)', srcset= '../assets/image/pc-sns.png')
          source(media='(min-width: 768px)', srcset= '../assets/image/ipad-sns.png')
          source(media='(min-width: 321px)', srcset= '../assets/image/sp-sns.png')
          img(src='../assets/image/sp-sns.png', alt='contact')
        .contact-icon-area
          .contact-icon
            a(href='https://www.facebook.com/sharer/sharer.php?u=http://www.recruit.mht-code.com', target="_blank")
              img.contact-facebookicon-img(:src="image_facebook")
            a(href='http://twitter.com/share?url=http://www.recruit.mht-code.com', target="_blank")
              img.contact-twittericon-img(:src="image_twitter")
        .link-btn-area
          .link-btn
            a(href='https://www.mht-code.com', target="_blank", data-hover="MANHATTAN CODE") MANHATTAN CODE
        picture
          source(media='(min-width: 1200px)', srcset= '../assets/image/pc-footer.png')
          source(media='(min-width: 768px)', srcset= '../assets/image/ipad-footer.png')
          source(media='(min-width: 321px)', srcset= '../assets/image/sp-footer.png')
          img(src='../assets/image/sp-footer.png', alt='contact')
    Footer
</template>

<script>
import Sp from '../assets/image/sp-first-view.png'
import Pc from '../assets/image/pc-first-view.png'
import SpPickupRecruit from '../assets/image/sp-pickup-recruit.png'
import SpContact from '../assets/image/sp-contact.png'
import SpSns from '../assets/image/sp-sns.png'
import SpFooter from '../assets/image/sp-footer.png'
import TwitterIcon from '../assets/image/twitter-icon.png'
import FacebookIcon from '../assets/image/facebook-icon.png'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Timeline from 'vue-tweet-embed/timeline'
export default {
  name: 'Home',
  data () {
    return {
      sp_pickup_recruit: SpPickupRecruit,
      sp_contact: SpContact,
      sp_sns: SpSns,
      sp_footer: SpFooter,
      image_twitter: TwitterIcon,
      image_facebook: FacebookIcon,
      sp: Sp,
      pc: Pc,
      twitterId: 'MHTcode_Rebecca'
    }
  },
  components: {
    Header,
    Footer,
    'v-timeline': Timeline
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue